import "./assets/index.css";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useReportAccidentCommand } from "./hooks/useReportAccidentCommand";
import { ROUTES } from "../../core/routes/routes";
import Textfield from "../../common/components/Textfiled";
import Select from "../../common/components/Select";
import Button from "../../common/components/Button";

function RegisterAccidents() {
  const location = useLocation();
  const navigate = useNavigate();
  const editData = location.state?.editData || null;
  const isEditing = !!editData;

  const {
    accident,
    handleChangeAccident,
    createReportAccident,
    updateReportAccident,
    setAccident,
    isSubmitting,
    errors: { errors },
  } = useReportAccidentCommand(() => {
    if (isEditing) navigate(ROUTES.LIST_ACCIDENTS);
  });

  useEffect(() => {
    if (editData) {
      setAccident({
        id: editData.id,
        dateAccident: editData.dateAccident || "",
        namePersonInvolved: editData.namePersonInvolved || "",
        documentPersonInvolved: editData.documentPersonInvolved || "",
        vehiclePlate: editData.vehiclePlate || "",
        typeContract: editData.typeContract || "",
        placeOfEvent: editData.placeOfEvent || "",
        fatality: editData.fatality ?? "",
        seriousInjuries: editData.seriousInjuries ?? "",
        minorInjuries: editData.minorInjuries ?? "",
        simpleShock: editData.simpleShock ?? "",
        ipat: editData.ipat || "",
        ipatAuthor: editData.ipatAuthor || "",
      });
    }
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isEditing) {
      updateReportAccident({ ...accident, id: editData.id });
    } else {
      createReportAccident(accident);
    }
  };

  return (
    <main class="container">
      <header class="header-container">
        <h1 class="header-title">{isEditing ? "Editar reporte de siniestros viales" : "Registrar reporte de siniestros viales"}</h1>
      </header>
      <section class="section-container">
        <form onSubmit={handleSubmit}>
          <div class="row row-cols-1 row-cols-md-2 g-2 mb-3">
            <Textfield
              label="Fecha del siniestro"
              type="date"
              name="dateAccident"
              value={accident.dateAccident}
              onChange={handleChangeAccident}
              error={errors.dateAccident}
            />
            <Textfield
              label="Nombre del implicado"
              name="namePersonInvolved"
              placeholder="Nombre completo"
              value={accident.namePersonInvolved}
              onChange={handleChangeAccident}
              error={errors.namePersonInvolved}
            />
            <Textfield
              label="Cédula del implicado"
              name="documentPersonInvolved"
              type="number"
              placeholder="Número de cédula"
              value={accident.documentPersonInvolved}
              onChange={handleChangeAccident}
              error={errors.documentPersonInvolved}
            />
            <Textfield
              label="Placa del vehículo implicado"
              name="vehiclePlate"
              placeholder="Número de placa"
              value={accident.vehiclePlate}
              onChange={handleChangeAccident}
              error={errors.vehiclePlate}
            />
            <Select
              label="Tipo de contratación"
              name="typeContract"
              value={accident.typeContract}
              onChange={handleChangeAccident}
              error={errors.typeContract}
              options={[
                { value: "termino fijo", label: "Termino fijo" },
                { value: "termino indefinido", label: "Termino indefinido" },
                { value: "contratista", label: "Contratista" },
                { value: "tercero", label: "Tercero" },
              ]}
            />
            <Textfield
              label="Lugar del suceso"
              name="placeOfEvent"
              placeholder="Lugar del suceso"
              value={accident.placeOfEvent}
              onChange={handleChangeAccident}
              error={errors.placeOfEvent}
            />
          </div>

          <h2 class="form-subtitle mb-2">Nivel de pérdida</h2>
          <div class="row row-cols-1 row-cols-md-2 g-2 mb-3">
            <Textfield
              label="Fatalidad"
              name="fatality"
              type="number"
              placeholder="Número de fallecidos"
              value={accident.fatality}
              onChange={handleChangeAccident}
              error={errors.fatality}
            />
            <Textfield
              label="Heridos graves"
              name="seriousInjuries"
              type="number"
              placeholder="Número de heridos graves"
              value={accident.seriousInjuries}
              onChange={handleChangeAccident}
              error={errors.seriousInjuries}
            />
            <Textfield
              label="Heridos leves"
              name="minorInjuries"
              type="number"
              placeholder="Número de heridos leves"
              value={accident.minorInjuries}
              onChange={handleChangeAccident}
              error={errors.minorInjuries}
            />
            <Textfield
              label="Choque simple"
              name="simpleShock"
              type="number"
              placeholder="Número de choques simples"
              value={accident.simpleShock}
              onChange={handleChangeAccident}
              error={errors.simpleShock}
            />
            <Textfield
              label="Informe Policial de Accidente de Tránsito (IPAT)"
              name="ipat"
              placeholder="Número de IPAT"
              value={accident.ipat}
              onChange={handleChangeAccident}
            />
            <Textfield
              label="Nombre de la autoridad que elaboro el reporte IPAT"
              name="ipatAuthor"
              placeholder="Nombre completo"
              value={accident.ipatAuthor}
              onChange={handleChangeAccident}
            />
          </div>

          <footer class="form-footer">
            <Button type="submit" loading={isSubmitting}>{isEditing ? "Actualizar" : "Registrar"}</Button>
          </footer>
        </form>
      </section>
    </main>
  );
}

export default RegisterAccidents;
